/*
 * Herroepingsformulier (TA-03) — sections/herroeping-form.liquid
 *
 * Bewust een gewoon script (geen ES-module, geen import map): de herroepingsfunctie
 * is wettelijk verplicht en moet ook in oudere browsers werken (zie TA-43).
 *
 * Flow: stap 1 valideren → stap 2 overzicht → "Herroeping bevestigen" → POST naar n8n
 * als text/plain (geen CORS-preflight, net als sample/offerte). n8n stuurt de
 * bevestigingsmail met datum en tijd; zie n8n/herroeping/README.md.
 *
 * Prefill: ?order=1234 (en optioneel &email=...) vult de velden, zodat de link in de
 * orderbevestigingsmail direct naar het juiste ordernummer kan wijzen.
 */
(function () {
  'use strict';

  var SUBMIT_TIMEOUT_MS = 15000;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function createId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    return 'h-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function normalizeOrder(value) {
    var v = String(value || '').trim().replace(/\s+/g, '');
    if (!v) return '';
    return v.charAt(0) === '#' ? v : '#' + v;
  }

  function formatDateTime(date) {
    try {
      return new Intl.DateTimeFormat('nl-NL', {
        dateStyle: 'long',
        timeStyle: 'short',
        timeZone: 'Europe/Amsterdam',
      }).format(date);
    } catch (e) {
      return date.toLocaleString('nl-NL');
    }
  }

  function init(root) {
    var form = root.querySelector('[data-herroeping-form]');
    if (!form || root.getAttribute('data-initialized') === 'true') return;
    root.setAttribute('data-initialized', 'true');

    var step1 = root.querySelector('[data-herroeping-step="1"]');
    var step2 = root.querySelector('[data-herroeping-step="2"]');
    var done = root.querySelector('[data-herroeping-done]');
    var error1 = root.querySelector('[data-herroeping-error]');
    var error2 = root.querySelector('[data-herroeping-submit-error]');
    var summary = root.querySelector('[data-herroeping-summary]');
    var productsField = root.querySelector('[data-herroeping-products]');
    var confirmBtn = root.querySelector('[data-herroeping-confirm]');
    var backBtn = root.querySelector('[data-herroeping-back]');
    var submissionUrl = root.getAttribute('data-submission-url');
    var fallbackEmail = root.getAttribute('data-fallback-email') || 'info@tegelmegastore.nl';
    var requestId = createId();
    var submitting = false;

    var params = new URLSearchParams(window.location.search);
    if (params.get('order')) form.elements.order_number.value = normalizeOrder(params.get('order'));
    if (params.get('email') && !form.elements.email.value) form.elements.email.value = params.get('email');

    function scope() {
      var checked = form.querySelector('[data-herroeping-scope]:checked');
      return checked ? checked.value : 'all';
    }

    function syncScope() {
      productsField.hidden = scope() !== 'partial';
    }
    Array.prototype.forEach.call(form.querySelectorAll('[data-herroeping-scope]'), function (input) {
      input.addEventListener('change', syncScope);
    });
    syncScope();

    function showError(el, message) {
      el.textContent = message;
      el.hidden = !message;
    }

    function markInvalid(input, invalid) {
      if (invalid) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
    }

    function collect() {
      var el = form.elements;
      return {
        name: el.name.value.trim(),
        email: el.email.value.trim(),
        order_number: normalizeOrder(el.order_number.value),
        scope: scope(),
        products: scope() === 'partial' ? el.products.value.trim() : '',
        note: el.note.value.trim(),
        website: el.website.value,
      };
    }

    function validate(data) {
      var el = form.elements;
      var problems = [];
      var first = null;
      function check(input, ok, message) {
        markInvalid(input, !ok);
        if (!ok) {
          problems.push(message);
          if (!first) first = input;
        }
      }
      check(el.name, data.name.length >= 2, 'Vul je naam in.');
      check(el.email, EMAIL_RE.test(data.email), 'Vul een geldig e-mailadres in.');
      check(el.order_number, /^#?[A-Za-z0-9-]{3,}$/.test(data.order_number), 'Vul je ordernummer in.');
      if (data.scope === 'partial') {
        check(el.products, data.products.length >= 3, 'Geef aan welke producten je herroept.');
      } else {
        markInvalid(el.products, false);
      }
      return { problems: problems, first: first };
    }

    function renderSummary(data) {
      var rows = [
        ['Naam', data.name],
        ['E-mailadres', data.email],
        ['Ordernummer', data.order_number],
        ['Herroeping', data.scope === 'partial' ? 'Deel van de bestelling' : 'De hele bestelling'],
      ];
      if (data.scope === 'partial') rows.push(['Producten', data.products]);
      if (data.note) rows.push(['Opmerking', data.note]);
      summary.textContent = '';
      rows.forEach(function (row) {
        var dt = document.createElement('dt');
        var dd = document.createElement('dd');
        dt.textContent = row[0];
        dd.textContent = row[1];
        summary.appendChild(dt);
        summary.appendChild(dd);
      });
    }

    function goTo(step) {
      step1.hidden = step !== 1;
      step2.hidden = step !== 2;
      var target = step === 2 ? step2 : form.elements.name;
      if (target && typeof target.focus === 'function') target.focus();
      root.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var data = collect();
      var result = validate(data);
      if (result.problems.length) {
        showError(error1, result.problems.join(' '));
        if (result.first) result.first.focus();
        return;
      }
      showError(error1, '');
      showError(error2, '');
      renderSummary(data);
      goTo(2);
    });

    backBtn.addEventListener('click', function () {
      goTo(1);
    });

    confirmBtn.addEventListener('click', function () {
      if (submitting) return;
      var data = collect();
      if (validate(data).problems.length) {
        goTo(1);
        return;
      }

      submitting = true;
      confirmBtn.disabled = true;
      confirmBtn.setAttribute('aria-busy', 'true');
      showError(error2, '');

      var submittedAt = new Date();
      var payload = {
        type: 'herroeping',
        request_id: requestId,
        submitted_at: submittedAt.toISOString(),
        name: data.name,
        email: data.email,
        order_number: data.order_number,
        scope: data.scope,
        products: data.products,
        note: data.note,
        website: data.website,
        page_url: window.location.href.split('#')[0],
        customer_id: root.getAttribute('data-customer-id') || null,
      };

      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = controller ? setTimeout(function () { controller.abort(); }, SUBMIT_TIMEOUT_MS) : null;

      fetch(submissionUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify(payload),
        signal: controller ? controller.signal : undefined,
      })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          form.hidden = true;
          done.hidden = false;
          done.querySelector('[data-herroeping-done-time]').textContent = formatDateTime(submittedAt);
          done.querySelector('[data-herroeping-done-email]').textContent = data.email;
          done.querySelector('[data-herroeping-done-ref]').textContent = requestId;
          done.focus();
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'herroeping_submitted', herroeping_scope: data.scope });
        })
        .catch(function () {
          var message =
            'Versturen is niet gelukt. Probeer het opnieuw, of stuur je herroeping (naam en ordernummer) per e-mail naar ' +
            fallbackEmail + '. Een herroeping per e-mail is net zo geldig.';
          showError(error2, message);
          confirmBtn.disabled = false;
          confirmBtn.removeAttribute('aria-busy');
          submitting = false;
        })
        .then(function () {
          if (timer) clearTimeout(timer);
        });
    });
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-herroeping-root]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
